import * as React from 'react'
import { ImageData } from './imageState'

type SourceProps = {
  srcSet: string
  media: string
}

export type PictureLayoutProps = {
  image: ImageData
  srcSet?: string
  sizes?: string
  width: string
  height: string
  extraClasses?: string
  lazyload: boolean
  fetchpriority?: 'high' | 'low'
}

export const PictureLayout = {
  PlaceholderSrc: '/spa/images/empty.png',
  Wrapper: (p: { className?: string; children: React.ReactNode }) => (
    <picture className={p.className}>{p.children}</picture>
  ),
  Source: (p: SourceProps) => <source srcSet={p.srcSet} media={p.media} />,
  Img: (p: PictureLayoutProps) => {
    const lazyload = p.lazyload && !window.isSSR
    return (
      <img
        src={!lazyload ? p.image.Url : PictureLayout.PlaceholderSrc}
        srcSet={!lazyload ? p.srcSet : undefined}
        sizes={lazyload || !p.srcSet ? undefined : p.sizes || '100vw'}
        data-src={lazyload ? p.image.Url : undefined}
        data-srcset={lazyload ? p.srcSet : undefined}
        data-sizes={lazyload && p.srcSet ? p.sizes || 'auto' : undefined}
        fetchpriority={lazyload ? 'low' : p.fetchpriority || 'high'}
        width={p.width}
        height={p.height}
        alt={p.image.Title || ''}
        className={`${p.extraClasses ? p.extraClasses : ''}${
          lazyload ? ' lazyload' : ' no-lazyload'
        }`}
      />
    )
  }
}
